<div class="container">
  <app-header class="header" [title]="'PAGES.WAKE_UP_ALARM.TITLE' | translate"></app-header>
  <app-alarm-setup class="content"></app-alarm-setup>
</div>
